import { InfoFilled } from '@element-plus/icons-vue'
import { ElButton, ElDialog, ElIcon } from 'element-plus'
import { computed, defineComponent, h, ref } from 'vue'

export default defineComponent({
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const isDialogVisible = ref(false)
    const modalTitle = computed(() => props.context.attrs?.modalTitle || '')
    const modalText = computed(() => props.context.attrs?.modalText || 'No additional information available.')
    const buttonText = computed(() => props.context.attrs?.buttonText || 'More Info')

    const showDialog = () => {
      isDialogVisible.value = true
    }

    return () =>
      h('div', { class: 'flex items-center gap-2' }, [
        h(
          ElButton,
          {
            type: 'primary',
            link: true,
            class: 'underline cursor-pointer',
            size: 'small',
            onClick: showDialog,
          },
          () => [h(ElIcon, { size: '16' }, () => h(InfoFilled)), ` ${buttonText.value}`],
        ),

        // Modal (Dialog)
        h(
          ElDialog,
          {
            modelValue: isDialogVisible.value,
            'onUpdate:modelValue': (val) => (isDialogVisible.value = val),
            title: modalTitle.value,
            width: '75%',
            appendToBody: true,
            zIndex: 4000,
          },
          {
            default: () =>
              h('div', {
                innerHTML: modalText.value,
                style: {
                  maxHeight: '400px',
                  overflowY: 'auto',
                  padding: '16px',
                },
              }),
            footer: () =>
              h(
                'div',
                { class: 'text-right' },
                h(
                  ElButton,
                  {
                    type: 'primary',
                    onClick: () => (isDialogVisible.value = false),
                  },
                  () => 'Close',
                ),
              ),
          },
        ),
      ])
  },
})
